import React from "react"; 

const BeadViewer = ({ beads }) => {

    return (
        <div className="bead-container">
            <h2>
                {beads.split("").map((char, index) => (
                    <div key={index} className="bead">
                        {char}
                    </div>
                ))}
            </h2>
        </div>
    );

};

export default BeadViewer;